import React from "react";
import { FiLayers, FiTool, FiEye, FiWifi, FiUsers, FiShield } from "react-icons/fi";

const items = [
  {
    icon: FiLayers,
    title: "Truly Custom",
    description:
      "No templates. Every solution is architected for your exact use case and infrastructure.",
  },
  {
    icon: FiTool,
    title: "Domain Depth",
    description:
      "We go deep into your domain — understanding workflows, constraints, and nuances before writing a single line of code.",
  },
  {
    icon: FiEye,
    title: "Vision Expertise",
    description:
      "Deep specialization in computer vision — from model training to real-time inference pipelines.",
  },
  {
    icon: FiWifi,
    title: "IoT Mastery",
    description:
      "Protocols, connectivity, edge computing, and sensor fusion — we speak the language of machines.",
  },
  {
    icon: FiUsers,
    title: "True Partnership",
    description:
      "We're invested in your success, not just delivery. We stay through maintenance and evolution.",
  },
  {
    icon: FiShield,
    title: "Built to Last",
    description:
      "Production-grade code engineered for reliability at scale — robust architecture, full documentation, and support through the entire lifecycle.",
  },
];

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="py-24 px-6 lg:px-20 bg-[#f8f8f8]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-['IBM_Plex_Mono'] text-[#F07023] text-xs tracking-[0.3em] uppercase">
            03 / Why Choose Us
          </span>
          <h2 className="text-[clamp(1.5rem,2.5vw,2.75rem)] font-[700] text-gray-900 mt-4 leading-tight">
            The difference is in our DNA
          </h2>
          <div className="w-12 h-px bg-[#F07023] mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className="group border-t-2 border-[#F07023]/25 pt-6 transition-colors duration-300 hover:border-[#F07023]"
              >
                <div className="flex items-center gap-3 mb-3">
                  <Icon className="text-[#F07023] text-xl flex-shrink-0" />
                  <h3 className="font-[600] text-gray-900">{item.title}</h3>
                </div>
                <p className="text-[#8892A4] text-sm leading-relaxed pl-7">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
